// GENERATED by scripts/fetch-cms.mjs — DO NOT EDIT.
// Source: Payload CMS (trainzilla-cms). Re-run `npm run cms:fetch`.

export type BlogCategory = {
  slug: string
  name: string
  description: string
  icon: string | null
  seo: { title?: string; description?: string; keywords?: string } | null
}

export const BLOG_CATEGORIES: BlogCategory[] = [
  {
    "slug": "nutrition",
    "name": "Nutrition",
    "description": "Diet planning, macros and meal swaps for coaches and their clients.",
    "icon": null,
    "seo": {}
  },
  {
    "slug": "client-management",
    "name": "Client Management",
    "description": "Retention, communication and coaching clients through real life.",
    "icon": null,
    "seo": {}
  },
  {
    "slug": "business-growth",
    "name": "Business & Growth",
    "description": "Client acquisition, pricing, marketing and payments for fitness businesses.",
    "icon": null,
    "seo": {}
  },
  {
    "slug": "ai-technology",
    "name": "AI & Technology",
    "description": "How AI and new tools are reshaping personal training and online coaching.",
    "icon": null,
    "seo": {}
  }
] as const
